import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    videoAlbums: [],
    count: '',
    next: '',
    details: {},
    newAlbum: {},
    errors: {}
};

getters['fetchVideoAlbums'] = function(state) {
    return state.videoAlbums;
}
getters['fetchNewVideoAlbum'] = function(state) {
    return state.newAlbum;
}
getters['fetchNextVideoAlbums'] = function(state) {
    return state.next;
}
getters['fetchVideoAlbumById'] = (state) => (id) => {
    if (state.videoAlbums) {
        return state.videoAlbums.find(album => album.id === id)
    }
    return {}
}
getters['fetchVideoDetails'] = function(state) {
    return state.details;
}
getters['fetchVideoAlbumsCount'] = function(state) {
    return state.count;
}

const actions = {
    get(context, payload) {
        return ApiService
            .get('profile/' + payload + '/video_albums/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VIDEO_ALBUMS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_VIDEO_ALBUMS', []);
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    getMy(context) {
        return ApiService
            .get('video_albums/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VIDEO_ALBUMS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_VIDEO_ALBUMS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    getDetails(context, payload) {
        return ApiService
            .get('video_albums/' + payload + '/detail')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_DETAILS', response.data);
            })
            .catch((response) => {
                if (response.status == 400) {
                    context.commit('SET_DETAILS', {});
                    context.commit('SET_ERROR', response.data);
                    throw new Error('Something goes wrong');
                }
            });
    },
    create(context, payload) {
        return ApiService
            .post('video_albums/create/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_NEW', response.data);
                context.commit('ADD_ALBUM', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    delete(context, payload) {
        return ApiService
            .delete('video_albums/' + payload + '/remove/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_VIDEO_ALBUMS', response.data)
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    update(context, payload) {
        return ApiService
            .patch('video_albums/' + payload.id + '/update/', payload.data)
            .then(() => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setEmptyNew(context, payload) {
        context.commit('SET_NEW', {});
    }
};

const mutations = {
    SET_VIDEO_ALBUMS(state, videoAlbums) {
        state.videoAlbums = videoAlbums;
        state.errors = {};
    },
    ADD_VIDEO_ALBUMS(state, videoAlbums) {
        state.videoAlbums = state.videoAlbums.concat(videoAlbums);
        state.errors = {};
    },
    ADD_ALBUM(state, album) {
        state.videoAlbums.push(album);
        state.errors = {};
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_NEW(state, newAlbum) {
        //console.log(newAlbum);
        state.newAlbum = newAlbum;
        state.errors = {};
    },
    SET_DETAILS(state, details) {
        state.details = details;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
